import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "block mb-3 font-bold text-sm",
  style: {"color":"#4C5669"}
}, "Rechercher un produit", -1)
const _hoisted_3 = { class: "flex-item relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search text-gray-500" })
], -1)
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_7 = { class: "card-toolbar w-full" }
const _hoisted_8 = { class: "formkit-selection" }
const _hoisted_9 = { class: "formkit-option" }
const _hoisted_10 = { class: "card-toolbar w-full" }
const _hoisted_11 = { class: "flex flex-col justify-center" }
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "ml-96 mt-10" }

import {computed, onBeforeMount, onMounted, ref, watch} from "vue";
import swal from "@/_helpers/swal";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import {fetchProductsForGrant, formatCategoriesProduct} from "@/_services/product/variant/productVariant";
import {getVariantProductCollection, updateVariantProductCollection} from "@/_services/grant/variantProductCollection";
import router from "@/router";
import {fetchCategoriesForDropDown} from "@/_services/category/category";
import {useRoute} from "vue-router";
import {
    IEditProductVariantToCollectionPlayload,
    IProductVariantForGrant
} from "@/models/product/variant/ProductVariantForGrant";
const tableLocalStorageKey = "tableSelectedProductsToAddInCollection";
const selectedProductToAddStorageKey = "editSelectedVariantProductsToAddInCollection";
const selectedProductToRemoveStorageKey = "editSelectedVariantProductsToRemoveFromCollection";
const selectAllBtnStatusStorageKey = "editSelectAllVariantProductsForCollectionBtnStatus";
const dbProductsOfCollectionInStorage = "editDbProductsOfCollectionInStorage";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'EditVariantProductCollection',
  setup(__props) {

const totalSelectedProductsToAdd = ref<number>(0);
const totalUnSelectedProducts = ref<number>(0);
const refItemsPerPage = ref<number>(0);
const productsOfCurrentPage = ref(Array<IProductVariantForGrant>());
const totalSelectedVariantProductsInDatabase = ref<number>(0);
const isFormSubmitted = ref(false);
const isLoading = ref<boolean>(true);
const vProducts = Array<IProductVariantForGrant>();
const tableData = ref<Array<IProductVariantForGrant>>(vProducts);
const selectedProducts = ref(Array<IProductVariantForGrant>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const variantProductCollectionUuid = ref<string>("");
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const selectedOptionsCategory = ref([]);
const route = useRoute();
const collectionName = ref<string>("");
const isSelectAllBtnChecked = ref(false);

onBeforeMount(() => {
    initLocalStorageData();
});

onMounted( async () => {
    variantProductCollectionUuid.value = route.params.uuid as string;
    await getVariantProductCollection(variantProductCollectionUuid.value).then((apiResult) => {
        collectionName.value = apiResult.data.data.name;
    });
    await populateDataTableWithLocalStorageFilters();
});

watch(selectedOptionsCategory, () => {
    onChangeSelectedCategory();
});

watch(isSelectAllBtnChecked, () => {
    setIsSelectedAllBtnStatusLocalStorage(isSelectAllBtnChecked.value);
});

const onChangeSelectedCategory = async (): Promise<void> => {
    showSpinner();
    const search = criteria.value.trim();
    await populateDatatable(rows.value, page.value, "" != search ? search : "", selectedOptionsCategory.value);
};

const isInFilteredView = computed(() => {
    return selectedOptionsCategory.value.length > 0 || totalSelectedProductsToAdd.value > 0 || totalUnSelectedProducts.value > 0;
});

async function searchCategories({ search, page, hasNextPage }) {
    const [totalCategoriesRecordsForPickListApi, categoriesForPickListApi] = await fetchCategoriesForDropDown(5, page, search);
    const hasItems = categoriesForPickListApi.length > 0;
    if (hasItems && page !== totalCategoriesRecordsForPickListApi) {
        hasNextPage();
    }

    return categoriesForPickListApi;
}

const submitHandler = async (data) => {
    swal
      .confirm("Êtes-vous sur de vouloir éditer cette collection ?")
      .then((result) => {
        if (result.isConfirmed) {
          showSpinner();
            const selectedProductsToAdd = getSelectedProductsToAddFromStorage();
            const unSelectedProductsToRemove = getUnSelectedProductsToRemoveFromStorage();
            const params: IEditProductVariantToCollectionPlayload = {
                uuid: variantProductCollectionUuid.value,
                name: data.name,
                selectedProductsUuidsToAdd: selectedProductsToAdd,
                unSelectedProductsUuidsToRemove: unSelectedProductsToRemove
            };
            updateVariantProductCollection(params).then(() => {
            swal.success(
                "Editer !", 
                "Vous venez de éditer une collection, la mise à jour de la catégorie " +
                "sera visible sur les subventions dans une heure").then(() => {
              router.push({ name: 'listVariantProductCollection'});
            });
          });
        }
      });
  
    isFormSubmitted.value = true
}

function onSearchInputDt() {
  let search = criteria.value.trim();
  if (search.length >= 0) {
    showSpinner();
    populateDatatable(rows.value, page.value, "" != search ? search : "", selectedOptionsCategory.value);
  }
}

const populateDatatable = async (itemsPerPage: number, page: number, criteria?: string | undefined, categoriesFilter?: string[] | undefined) => {
  const [loadingDt, totalRecordsDt, tableDataDt] = await fetchProductsForGrant(
    itemsPerPage,
    page,
    criteria,
    categoriesFilter,
    variantProductCollectionUuid.value
  );
  totalRecords.value = totalRecordsDt;
  isLoading.value = loadingDt;
  tableData.value = tableDataDt;
  refItemsPerPage.value = itemsPerPage;
  productsOfCurrentPage.value = tableData.value;
  totalSelectedVariantProductsInDatabase.value = productsOfCurrentPage.value[0]?.totalSelectedVariantProducts;
  const selectedProductsUuidsInDatabaseOnCurrentPage = productsOfCurrentPage.value
      .filter(item => item.isVariantProductInCollection === true)
      .map(item => item.uuid);
  addDbProductsToCollectionInStorage(selectedProductsUuidsInDatabaseOnCurrentPage);
  let selectedProductsOnCurrentPage: IProductVariantForGrant[] = [];
    selectedProductsOnCurrentPage = productsOfCurrentPage.value.filter((item: IProductVariantForGrant) =>
    (getSelectedProductsToAddFromStorage().includes(item.uuid) || getDatabaseSelectedProductOfCollectionFromStorage().includes(item.uuid))
    && !getUnSelectedProductsToRemoveFromStorage().includes(item.uuid));

    const totalUnSelectedProductsOnCurrentPage = getTotalUnSelectedProductsOnCurrentPage();
    isSelectAllBtnChecked.value = (itemsPerPage - totalUnSelectedProductsOnCurrentPage) === itemsPerPage;
    selectedProducts.value = selectedProductsOnCurrentPage;
}

async function populateDataTableWithLocalStorageFilters(itemsPerPage?: number, page?: number) {
  let localStorageRowPerPage = getLocalStorageRowsPerPage();
  let localStorageFisrtPageState = getLocalStorageFisrtPageState();
  let currentPage = page;
  if (!currentPage) {
    currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
  }
  let currentItemsPerPage = itemsPerPage;
  if (!currentItemsPerPage) {
    currentItemsPerPage = localStorageRowPerPage;
  }

  await populateDatatable(currentItemsPerPage as number, currentPage, criteria.value, selectedOptionsCategory.value);
}

async function onPaginate(e) { 
  rows.value = e.rows;
  page.value = e.page + 1;
  showSpinner();
  setLocalStorageRowsPerPage(rows.value);
  await populateDataTableWithLocalStorageFilters(rows.value, page.value);
}

const onRowSelect = async (event: any): Promise<void> => {
    const selectedProductUuid = event.data.uuid;
    removeSelectedProductInProductsToRemoveInStorage([selectedProductUuid]);
    if (!getDatabaseSelectedProductOfCollectionFromStorage().includes(selectedProductUuid)) {
        totalSelectedProductsToAdd.value++;
        addSelectedProductInProductsToAddInStorage([selectedProductUuid]);
    }

    const currentProductsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
    let newTotalProductsToRemoveInStorage = currentProductsToRemoveInStorage.filter(uuid => !selectedProductUuid.includes(uuid));
    totalUnSelectedProducts.value = newTotalProductsToRemoveInStorage.length;
    const totalSelectedProductsOnCurrentPage = getTotalUnSelectedProductsOnCurrentPage();
    isSelectAllBtnChecked.value = (refItemsPerPage.value - totalSelectedProductsOnCurrentPage) === refItemsPerPage.value;
}

const onRowUnselect = async (event: any): Promise<void> => {
    const unSelectedProductUuid = event.data.uuid;
    removeUnSelectedProductFromProductsToAddInStorage([unSelectedProductUuid]);
    if (getDatabaseSelectedProductOfCollectionFromStorage().includes(unSelectedProductUuid)) {
        addUnSelectedProductInProductsToRemoveInStorage([unSelectedProductUuid]);
        totalUnSelectedProducts.value = getUnSelectedProductsToRemoveFromStorage().length++;
    }

    const productsToAddInStorage = getSelectedProductsToAddFromStorage();
    let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !unSelectedProductUuid.includes(uuid));
    totalSelectedProductsToAdd.value = newProductsToAddInStorage.length;
    isSelectAllBtnChecked.value = false;
}

const onRowSelectAll = async (event): Promise<void> => {
    if (true === event.checked) {
        isSelectAllBtnChecked.value = true;
        selectedProducts.value = productsOfCurrentPage.value;
        const selectedProductsUuidsToRemoveInStorage = productsOfCurrentPage.value
            .filter((item: IProductVariantForGrant) =>
                getDatabaseSelectedProductOfCollectionFromStorage().includes(item.uuid) ||
                getUnSelectedProductsToRemoveFromStorage().includes(item.uuid)
            )
            .map(item => item.uuid);
        removeSelectedProductInProductsToRemoveInStorage(selectedProductsUuidsToRemoveInStorage);

        const selectedProductUuidToSaveInDatabase = productsOfCurrentPage.value
            .filter((item: IProductVariantForGrant) =>
                !getDatabaseSelectedProductOfCollectionFromStorage().includes(item.uuid)
            )
            .map(item => item.uuid);
        if (selectedProductUuidToSaveInDatabase.length > 0) {
            addSelectedProductInProductsToAddInStorage(selectedProductUuidToSaveInDatabase);
            const currentProductsToAddInStorage = getSelectedProductsToAddFromStorage();
            let newProductsToAddInStorage = currentProductsToAddInStorage;
            selectedProductUuidToSaveInDatabase.forEach((uuid: string) => {
                if (!currentProductsToAddInStorage.includes(uuid)) {
                    newProductsToAddInStorage.push(uuid);
                }
            });
            totalSelectedProductsToAdd.value = newProductsToAddInStorage.length;
        }

        const currentProductsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
        let newTotalProductsToRemoveInStorage = currentProductsToRemoveInStorage.filter(uuid => !selectedProductsUuidsToRemoveInStorage.includes(uuid));
        totalUnSelectedProducts.value = newTotalProductsToRemoveInStorage.length;
    } else {
        isSelectAllBtnChecked.value = false;
        const unSelectedProductsToRemoveInDatabase = productsOfCurrentPage.value
            .filter((item: IProductVariantForGrant) =>
                !getDatabaseSelectedProductOfCollectionFromStorage().includes(item.uuid) ||
                getSelectedProductsToAddFromStorage().includes(item.uuid)
            );
        const unSelectedProductsUuidsToRemoveInDatabase = unSelectedProductsToRemoveInDatabase.map(item => item.uuid);
        removeUnSelectedProductFromProductsToAddInStorage(unSelectedProductsUuidsToRemoveInDatabase);

        const unSelectedProductsToRemoveInStorage = productsOfCurrentPage.value
            .filter((item: IProductVariantForGrant) =>
                getDatabaseSelectedProductOfCollectionFromStorage().includes(item.uuid)
            );
        const unSelectedProductsUuidsToRemoveInStorage = unSelectedProductsToRemoveInStorage.map(item => item.uuid);
        if (unSelectedProductsUuidsToRemoveInStorage.length > 0) {
            addUnSelectedProductInProductsToRemoveInStorage(unSelectedProductsUuidsToRemoveInStorage);
            const productsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
            let newProductsToRemoveInStorage = productsToRemoveInStorage;
            unSelectedProductsUuidsToRemoveInStorage.forEach((uuid: string) => {
                if (!productsToRemoveInStorage.includes(uuid)) {
                    newProductsToRemoveInStorage.push(uuid);
                }
            });
            totalUnSelectedProducts.value = newProductsToRemoveInStorage.length;
        }

        const productsToAddInStorage = getSelectedProductsToAddFromStorage();
        let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !unSelectedProductsUuidsToRemoveInDatabase.includes(uuid));
        totalSelectedProductsToAdd.value = newProductsToAddInStorage.length;
        selectedProducts.value = selectedProducts.value.filter((item: IProductVariantForGrant) =>
            !productsOfCurrentPage.value.map((product: IProductVariantForGrant) => product.uuid).includes(item.uuid)
        );

        hideSpinner();
    }
}

const setIsSelectedAllBtnStatusLocalStorage = (status: boolean) =>{
    isSelectAllBtnChecked.value = status;

    const isSelectedAllBtnInStorageData = localStorage.getItem(selectAllBtnStatusStorageKey);
    if (!isSelectedAllBtnInStorageData) {
        localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
    } else {
        const currentStatus = JSON.parse(isSelectedAllBtnInStorageData);
        if (currentStatus !== status) {
            localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
        }
    }
}

function getLocalStorageData() {
  let storageData = localStorage.getItem(tableLocalStorageKey);

  if (null !== storageData && "undefined" !== storageData) {
    return JSON.parse(storageData);
  }

  return null;
}

const getTotalUnSelectedProductsOnCurrentPage = (): number => {
    const totalUnselectedCurrentPageProductsNotInDbAndAddFromStorage = productsOfCurrentPage.value.filter((item: IProductVariantForGrant) =>
        (!getSelectedProductsToAddFromStorage().includes(item.uuid) && !getDatabaseSelectedProductOfCollectionFromStorage().includes(item.uuid))).length;
    const totalUnselectedCurrentPageProductsOnStorage = productsOfCurrentPage.value.filter((item: IProductVariantForGrant) =>
        getUnSelectedProductsToRemoveFromStorage().includes(item.uuid)).length;

    return totalUnselectedCurrentPageProductsOnStorage + totalUnselectedCurrentPageProductsNotInDbAndAddFromStorage;
};

const getDatabaseSelectedProductOfCollectionFromStorage = (): string[] => {
    const initSelectedProductsOfCollection = localStorage.getItem(dbProductsOfCollectionInStorage);
    return initSelectedProductsOfCollection ? JSON.parse(initSelectedProductsOfCollection) : [];
}

const addDbProductsToCollectionInStorage = (UuidsCheckedInDb: string[]) => {
    let initProductsOfCollectionInStorage = getDatabaseSelectedProductOfCollectionFromStorage();
    UuidsCheckedInDb.forEach(uuid => {
        if (!initProductsOfCollectionInStorage.includes(uuid)) {
            initProductsOfCollectionInStorage.push(uuid);
        }
    });
    localStorage.setItem(dbProductsOfCollectionInStorage, JSON.stringify(initProductsOfCollectionInStorage));
}

const getSelectedProductsToAddFromStorage = (): string[] => {
    const selectedProductsToAdd = localStorage.getItem(selectedProductToAddStorageKey);
    return selectedProductsToAdd ? JSON.parse(selectedProductsToAdd) : [];
}

const addSelectedProductInProductsToAddInStorage = (uuids: string[]) => {
    if (uuids.length === 0) {
        totalSelectedProductsToAdd.value = 0;
        localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify([]));
        return;
    }

    let productsToAddInStorage = getSelectedProductsToAddFromStorage();
    uuids.forEach(uuid => {
        if (!productsToAddInStorage.includes(uuid)) {
            productsToAddInStorage.push(uuid);
        }
    });
    localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify(productsToAddInStorage));
}

const removeUnSelectedProductFromProductsToAddInStorage = (uuids: string[]) => {
    let productsToAddInStorage = getSelectedProductsToAddFromStorage();
    let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !uuids.includes(uuid));
    localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify(newProductsToAddInStorage));
}

const getUnSelectedProductsToRemoveFromStorage = (): string[] => {
    const unSelectedProductsToRemove = localStorage.getItem(selectedProductToRemoveStorageKey);
    return unSelectedProductsToRemove ? JSON.parse(unSelectedProductsToRemove) : [];
}

const addUnSelectedProductInProductsToRemoveInStorage = (uuids: string[]) => {
    if (uuids.length === 0) {
        totalUnSelectedProducts.value = 0;
        localStorage.setItem(selectedProductToRemoveStorageKey, JSON.stringify([]));
        return;
    }

    let productsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
    uuids.forEach(uuid => {
        if (!productsToRemoveInStorage.includes(uuid)) {
            productsToRemoveInStorage.push(uuid);
        }
    });
    localStorage.setItem(selectedProductToRemoveStorageKey, JSON.stringify(productsToRemoveInStorage));
}

const removeSelectedProductInProductsToRemoveInStorage = (uuidsToRemove: string[]) => {
    let currentProductsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
    let newProductsToRemoveInStorage = currentProductsToRemoveInStorage.filter(uuid => !uuidsToRemove.includes(uuid));
    localStorage.setItem(selectedProductToRemoveStorageKey, JSON.stringify(newProductsToRemoveInStorage));
}

function getSelectedProductUuids() {
  let localStorageData = getLocalStorageData();
  return localStorageData.selection.map(({ uuid }) => uuid)
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
  let storageData = localStorage.getItem(tableLocalStorageKey);
  if (null !== storageData) {
    let localStorageObject = JSON.parse(storageData);
    localStorageObject.rows = rowPerPage;
    localStorage.setItem(tableLocalStorageKey, JSON.stringify(localStorageObject));
  }
}

function getLocalStorageRowsPerPage() {
  let localStorageData = getLocalStorageData();
  if (null !== localStorageData && localStorageData.rows) {
    return localStorageData.rows;
  }

  return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
  let localStorageData = getLocalStorageData();
  if (null !== localStorageData && localStorageData.first) {
    return localStorageData.first;
  }

  return 0;
}

const initLocalStorageData = () => {
    // Delete
    if (localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.removeItem(selectAllBtnStatusStorageKey);
    }
    if (localStorage.getItem(tableLocalStorageKey)) {
        localStorage.removeItem(tableLocalStorageKey);
    }
    if (localStorage.getItem(selectedProductToAddStorageKey)) {
        localStorage.removeItem(selectedProductToAddStorageKey);
    }
    if (localStorage.getItem(selectedProductToRemoveStorageKey)) {
        localStorage.removeItem(selectedProductToRemoveStorageKey);
    }
    if (localStorage.getItem(dbProductsOfCollectionInStorage)) {
        localStorage.removeItem(dbProductsOfCollectionInStorage);
    }

    // Create
    if (!localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.setItem(selectAllBtnStatusStorageKey, 'false');
    }
    if (!localStorage.getItem(selectedProductToAddStorageKey)) {
        localStorage.setItem(selectedProductToAddStorageKey, '[]');
    }
    if (!localStorage.getItem(selectedProductToRemoveStorageKey)) {
        localStorage.setItem(selectedProductToRemoveStorageKey, '[]');
    }
    if (!localStorage.getItem(dbProductsOfCollectionInStorage)) {
        localStorage.setItem(dbProductsOfCollectionInStorage, '[]');
    }
}

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(InputText), {
          type: "text",
          modelValue: criteria.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
          placeholder: "Recherche",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (onSearchInputDt()), ["enter"])),
          class: "pl-10 w-64 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_FormKit, {
      type: "form",
      "form-class": isFormSubmitted.value ? 'hide' : 'show',
      onSubmit: submitHandler,
      actions: false
    }, {
      default: _withCtx(({ state: { valid } }) => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(DataTable), {
            lazy: "",
            dataKey: "uuid",
            stateStorage: "local",
            ref: "dt",
            "state-key": tableLocalStorageKey,
            value: tableData.value,
            paginator: true,
            rows: rows.value,
            rowHover: true,
            removableSort: "",
            selection: selectedProducts.value,
            "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((selectedProducts).value = $event)),
            loading: isLoading.value,
            totalRecords: totalRecords.value,
            currentPage: currentPage.value,
            selectAll: isSelectAllBtnChecked.value,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            rowsPerPageOptions: rowsPerPageOptions,
            currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
            onSelectAllChange: _cache[4] || (_cache[4] = ($event: any) => (onRowSelectAll($event))),
            onRowSelect: _cache[5] || (_cache[5] = ($event: any) => (onRowSelect($event))),
            onRowUnselect: _cache[6] || (_cache[6] = ($event: any) => (onRowUnselect($event))),
            onPage: _cache[7] || (_cache[7] = ($event: any) => (onPaginate($event)))
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_FormKit, {
                    type: "autocomplete",
                    name: "autocomplete",
                    label: "Rechercher une catégorie",
                    placeholder: "Example: E-billet",
                    modelValue: selectedOptionsCategory.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOptionsCategory).value = $event)),
                    options: searchCategories,
                    "selection-appearance": "option",
                    multiple: ""
                  }, {
                    selection: _withCtx(({ option }) => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(option.label), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", null, "Nombre total de produits : " + _toDisplayString(totalRecords.value), 1),
                    _createElementVNode("p", null, "Nombre de produit déjà sélectionnée(s) : " + _toDisplayString(totalSelectedVariantProductsInDatabase.value) + " produit(s)", 1),
                    _createElementVNode("p", null, "Nombre de produit à rajouter : " + _toDisplayString(totalSelectedProductsToAdd.value), 1),
                    _createElementVNode("p", null, "Nombre de produit à supprimer : " + _toDisplayString(totalUnSelectedProducts.value), 1),
                    _withDirectives(_createElementVNode("p", null, "Vous êtes en vue filtrée", 512), [
                      [_vShow, isInFilteredView.value]
                    ])
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode("Aucun résultat trouvé.")
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(Column), { selectionMode: "multiple" }),
                _createVNode(_unref(Column), {
                  field: "name",
                  header: "Produit"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "category",
                  header: "Catégorie"
                }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.categories?.length > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          title: _unref(formatCategoriesProduct)(slotProps.data.categories)
                        }, _toDisplayString(slotProps.data.categories[0].value), 9, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "price",
                  header: "Prix"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", null, _toDisplayString(slotProps.data.priceFormatted), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["value", "rows", "selection", "loading", "totalRecords", "currentPage", "selectAll"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_FormKit, {
            type: "text",
            name: "name",
            label: "Nom de la collection*",
            validation: "required",
            modelValue: collectionName.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((collectionName).value = $event)),
            "validation-messages": { required: 'Ce champ est obligatoire.' }
          }, null, 8, ["modelValue", "validation-messages"]),
          _createVNode(_component_FormKit, {
            type: "submit",
            label: "Enregistrer",
            disabled: !valid || isLoading.value
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["form-class"])
  ], 64))
}
}

})